module.exports = {
  apiKey: "AIzaSyAFuKG3rz2ClMZ5YJJQ0pf34ja0p41Z7Hk",
  authDomain: "metro-c7c33.firebaseapp.com",
  databaseURL: "https://metro-c7c33.firebaseio.com",
  projectId: "metro-c7c33",
  storageBucket: "metro-c7c33.appspot.com",
  messagingSenderId: "789855294032"
}



// WEBPACK FOOTER //
// ./src/env.js